export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
}

export const categories: Category[] = [
  {
    slug: 'romance',
    name: '恋爱',
    description: '甜蜜浪漫的韩国恋爱漫画，感受心动瞬间',
    icon: 'ri-heart-line',
  },
  {
    slug: 'fantasy',
    name: '奇幻',
    description: '穿越异世界，探索魔法与冒险的奇幻世界',
    icon: 'ri-magic-line',
  },
  {
    slug: 'action',
    name: '动作',
    description: '热血沸腾的动作场面，激战不断的精彩故事',
    icon: 'ri-sword-line',
  },
  {
    slug: 'drama',
    name: '剧情',
    description: '扣人心弦的剧情发展，引人入胜的故事叙述',
    icon: 'ri-film-line',
  },
  {
    slug: 'thriller',
    name: '惊悚',
    description: '悬疑惊悚的紧张氛围，让你欲罢不能',
    icon: 'ri-ghost-line',
  },
  {
    slug: 'comedy',
    name: '喜剧',
    description: '轻松搞笑的日常喜剧，带给你欢乐时光',
    icon: 'ri-emotion-laugh-line',
  },
  {
    slug: 'slice-of-life',
    name: '日常',
    description: '温馨治愈的日常生活，平凡中的不平凡',
    icon: 'ri-home-heart-line',
  },
  {
    slug: 'bl',
    name: '耽美',
    description: '唯美动人的耽美故事，细腻的情感描绘',
    icon: 'ri-star-line',
  },
];